module.exports = __webpack_public_path__ + "img/img19.d9dffe31.png";